/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";

// Settings page components
import DashboardLayout from "LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Skill90DashboardNavbar";
import Sidenav from "./components/Sidenav";
import BasicInfo from "./components/BasicInfo";
import ChangePassword from "./components/ChangePassword";
import Sessions from "./components/Sessions";
import DeleteAccount from "./components/DeleteAccount";

// react-router components
import { useNavigate } from "react-router-dom";

import DialogBox from "Modals/CheckLeavePage";
import { useCallbackPrompt } from "hooks/useCallbackPrompt";

function Account() {
  const [showDialog, setShowDialog] = useState(false);
  const [showPrompt, confirmNavigation, cancelNavigation] = useCallbackPrompt(showDialog);

  const navigate = useNavigate();

  // Navigate to any path
  const routeChange = (path) => {
    navigate(path);
  };

  function signalClose() {
    routeChange("/account");
  }

  function handleChanges(data) {
    if (data) {
      setShowDialog(true);
    } else {
      setShowDialog(false);
    }
  }

  return (
    <DashboardLayout>
      <DialogBox
        // @ts-ignore
        showDialog={showPrompt}
        confirmNavigation={confirmNavigation}
        cancelNavigation={cancelNavigation}
      />
      <DashboardNavbar />
      <SoftBox my={3} sx={{ marginBottom: "0px" }}>
        <SoftBox
          display="flex"
          justifyContent="space-between"
          alignItems="flex-start"
          p={3}
          sx={{ paddingTop: "0px", paddingRight: "0px" }}
        >
          <SoftBox mt={0}>
            <Grid container spacing={3}>
              <Grid item xs={12} lg={3} className="secondary-menu-fixed">
                <Sidenav />
              </Grid>
              <Grid item xs={12} lg={9} className="scrolling-main-page">
                <SoftBox mb={3}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sx={{ paddingTop: "0px" }}>
                      <BasicInfo signalCloseModal={signalClose} informParent={handleChanges} />
                    </Grid>
                    <Grid item xs={12}>
                      <ChangePassword informParent={handleChanges} checkChanges={true} />
                    </Grid>
                    <Grid item xs={12}>
                      <DeleteAccount />
                    </Grid>
                    <Grid item xs={12}>
                      <Sessions />
                    </Grid>
                    <Grid item xs={12}>
                      <div style={{ height: "calc(100vh - 320px)" }}></div>
                    </Grid>
                  </Grid>
                </SoftBox>
              </Grid>
            </Grid>
          </SoftBox>
        </SoftBox>
      </SoftBox>
    </DashboardLayout>
  );
}

export default Account;
